<div class="flex flex-row">
    <div class="flex items-center gap-3">
        <fa-icon
            class="text-custom-blue mr-2 title-icon cursor-pointer"
            size="lg"
            [icon]="['far', 'arrow-left']"
            [matTooltip]="'back' | transloco"
            (click)="goToPreviousPage.emit()" />
        <span class="title font-medium text-2xl">
            {{ title() }}
        </span>
    </div>
</div>
